import { Layers, MessageSquare, FileCheck2 } from "lucide-react";

import type { ItemVariant } from "../utils/item-status";
import { ITEM_STATUS_LABELS } from "../constants";

const CONFIG: Record<ItemVariant, { label: string; className: string; icon: typeof Layers }> = {
  free: {
    label: ITEM_STATUS_LABELS.free,
    className: "bg-slate-50 text-slate-600 border-slate-200",
    icon: FileCheck2,
  },
  draft: {
    label: ITEM_STATUS_LABELS.draft,
    className: "bg-yellow-50 text-yellow-700 border-yellow-200",
    icon: MessageSquare,
  },
  reconciled: {
    label: ITEM_STATUS_LABELS.reconciled,
    className: "bg-blue-50 text-blue-700 border-blue-200",
    icon: Layers,
  },
};

function resolveLabel(
  variant: ItemVariant,
  fallback: string,
  batchId?: number | null,
  draftId?: number | null,
): string {
  if (variant === "reconciled" && batchId) return `Conciliação #${batchId}`;
  if (variant === "draft" && draftId) return `Rascunho #${draftId}`;
  return fallback;
}

export function ItemStatusBadge({
  variant,
  batchId,
  draftId,
}: {
  variant: ItemVariant;
  batchId?: number | null;
  draftId?: number | null;
}) {
  const cfg = CONFIG[variant];
  const Icon = cfg.icon;
  const label = resolveLabel(variant, cfg.label, batchId, draftId);
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-xs font-medium ${cfg.className}`}
    >
      <Icon className="h-3 w-3" />
      {label}
    </span>
  );
}
